<template>
  <OpenCourses />
</template>

<script>
import OpenCourses from "@/components/course/OpenCourses.vue"

export default {
  components: {
    OpenCourses
  }
}
</script>

<style>

</style>